export class FileList {
  originalFile: File;
  imageLocalUrl: string;
  imageUrl?: string;
  fileName?: string;
}
